import { Stack, Typography } from "@mui/material";
import i18n from "../../../../../../../i18n";
import { CalendarIcon } from "../assets";
import styles from "./DataBar.module.css";

type DataBarProps = {
	candidateName: string;
	positionName: string;
	startTime?: Date;
};

function formatDate(date: Date) {
	return new Intl.DateTimeFormat("en-US", {
		weekday: "long",
		month: "long",
		day: "numeric",
		year: "numeric",
		hour: "2-digit",
		minute: "2-digit",
		hour12: false,
	})
		.format(date)
		.replace(",", "") // remove comma after weekday
		.replace(/(\d{4})/, "$1 at");
}

export default function DataBar({ candidateName, positionName, startTime }: DataBarProps) {
	return (
		<div className={styles.dataBar}>
			<Stack direction="row" gap="16px">
				<Typography>
					<span className={styles.label}>{i18n.t("candidate.scheduleInterview.successPage.headers.candidate")}</span>{" "}
					<span className={styles.value}>{candidateName}</span>
				</Typography>
				<div className={styles.divider} />
				<Typography>
					<span className={styles.label}>{i18n.t("candidate.scheduleInterview.successPage.headers.position")}</span>{" "}
					<span className={styles.value}>{positionName}</span>
				</Typography>
				<div className={styles.divider} />
				<Stack direction="row" gap="4px" alignItems="center">
					<CalendarIcon />
					<Typography className={styles.value}>
						{startTime ? formatDate(startTime) : i18n.t("candidate.scheduleInterview.successPage.headers.date.invalid")}
					</Typography>
				</Stack>
			</Stack>
		</div>
	);
}
